import { TimeStamp } from './Common';
import { ShopResponse } from './Shop';

export interface DepartmentResponse extends TimeStamp {
  departmentId: number;
  departmentType : DepartmentType;
  name: string;
  districtCode: string | null;
  title: string | null;
  shopId: number | null;
  belongsDepartmentId: number | null;
  BelongsDepartment: DepartmentResponse | null;
  SubDepartments: DepartmentResponse[];
  Shop: ShopResponse | null;
}

export enum DepartmentTypeEnum {
  'global' = 'SV Global',
  'group' = 'SV Group',
  'family' = 'Family',
  'district' = 'District',
}

export type DepartmentType = keyof typeof DepartmentTypeEnum;
